import React from 'react';
import { isMobile, isIpad, isDesktop } from '../../utils/ScreenSizeHelper';

import TextTransformation from '../../utils/textTransformation'
const Receipt = React.forwardRef(({ data }, ref) => {

    const StyleTotalBlock = {
        fontFamily: 'Inter Medium',
        fontSize: '12px'
    }


    const StyleNumberBlock = {
        fontFamily: 'Inter Medium',
        fontSize: '12px'
    }

    const [startNo, endNo] = (data?.order_no || '').split('-')
    const isMealOrder = endNo?.includes('MEAL')

    const promoTypeLabel = (discount_type, discountedAmount) => {
        // You have to create paths on app.js before coming here to add tan name
        switch (discount_type) {
            case 'percentage':
                return `${discountedAmount}% off`;
            case 'plates':
                return `${discountedAmount} Free meal`;
            case 'amount_off':
                return `- $${discountedAmount} off`;
            case 'product':
                return `- $${discountedAmount} off`;
            case 'free_delivery':
                return `- $${discountedAmount} Delivery off`;
            case 'percentage_delivery':
                return `${discountedAmount}% Delivery off`;
            case 'free':
                return `Free order`;

        }
    }



    return (<div ref={ref} style={{ padding: 20, fontFamily: 'monospace' }}>

        <div >

            <div style={{ fontFamily: 'Inter Bold', fontSize: '16px' }}>{data.kitchen_name}</div>
            <div style={{ fontSize: '12px', marginBottom: '10px' }}> {data.kitchen_geolocation?.formattedAddress}</div>
            <div style={{ fontFamily: 'Inter Bold', fontSize: '26px', marginTop: '10px', marginBottom: '10px' }}>{data?.order_no?.slice(-5)}</div>
            <div style={{ fontSize: '12px' }}> {endNo}</div>
            <div style={{ fontSize: '12px' }}>{data.delivery_date}</div>
            <div style={{ fontSize: '14px', fontFamily: 'Inter Bold', textTransform: 'capitalize' }}> {data?.cust_firstName} {data?.cust_lastName}</div>


            {isMealOrder === false && Object.keys(data).length > 0 && (
                <div style={{ marginTop: '20px', width: '100%', marginLeft: '1px' }}>
                    <div style={{ marginLeft: '1px', fontFamily: 'Inter Medium', fontSize: '12px', color: 'black', }}>
                        Item{data?.item_names?.length > 1 ? 's' : ''}
                    </div>
                    <div style={{ margin: '1px', alignContent: 'center' }}>
                        {data?.item_names?.map((item, i) => {

                            let price = 'Meal item'
                            let isMealItem = false

                            if (item?.price) {
                                price = item.qty * item.price;
                            }


                            if (item?.product_category) {
                                isMealItem = true
                            }


                            const displayPrice = (price === 'Meal item') ? 'Meal item' : `$${price}`;

                            if (item?.promotion === 'buy_one_get_one_free' && price !== 'Meal item' && item.qty > 1) {
                                price = (item.qty - Math.floor(item.qty / 2)) * item.price;
                            } else if (item?.promotion === 'buy_two_get_one_free' && price !== 'Meal item' && item.qty > 2) {
                                price = (item.qty - Math.floor(item.qty / 3)) * item.price;
                            } else if (item?.promotion === 'buy_one_get_half_price' && price !== 'Meal item' && item.qty > 1) {
                                price = ((item.qty - Math.floor(item.qty / 2)) + (Math.floor(item.qty / 2) / 2)) * item.price;
                            }

                            return (
                                <div style={{ alignContent: 'center', marginBottom: '10px' }} key={`${item}_${i}`}>
                                    <div style={{ display: 'flex', flexDirection: 'row', alignText: 'center', alignContent: 'center' }}>

                                        <div style={{
                                            display: 'flex', fontFamily: 'Inter Medium', fontSize: '11px', justifyContent: 'center', backgroundColor: '#e8e7e9', alignItems: 'center',
                                            border: '1px solid #c7c7c7', borderRadius: '3px', height: '18px', width: '22px', margin: '0px 10px 5px 0px',
                                        }}>{item.qty}</div>
                                        <div style={{ display: 'flex', flexDirection: 'column', }}>
                                            <div style={{ fontFamily: 'Inter Bold', fontSize: '12px', color: '#181436', textTransform: 'capitalize', letterSpacing: '0.5px' }}>{item.item}</div>
                                            {item?.promotion && <div style={{ fontFamily: 'Inter Regular', fontSize: '12px', color: 'black', marginTop: '2px', marginBottom: '5px' }}>
                                                Applied - <a style={{ fontFamily: 'Inter Medium', fontSize: '13px', color: 'black' }}> {TextTransformation(item?.promotion)}</a></div>}
                                            {isMealItem && <div style={{ fontSize: '12px', fontFamily: 'Inter Regular', color: 'lightgray' }}> Meal item</div>}
                                        </div>
                                        <div style={{
                                            flex: 1, textAlign: 'right', fontFamily: 'Inter Medium',
                                            fontSize: '14px', color: '#181436', marginLeft: '10px'
                                        }}> {displayPrice}</div>

                                    </div>
                                    {item?.extra_toppings?.map((t, j) => (
                                        <div style={{ display: 'flex', flexDirection: 'row', margin: '0px 0px 0px 35px', }} key={t.topping_name}>
                                            <div style={{ fontFamily: 'Inter Regular', fontSize: '13px', color: '#181436', marginRight: '30px', textTransform: 'capitalize', letterSpacing: '0.5px' }}>{`${t.topping_name} (${t.topping_qty})`}</div>
                                            <div style={{ fontFamily: 'Inter Regular', fontSize: '13px', color: '#181436', marginRight: '10px' }}>${(t.topping_qty * t.price).toFixed(2)}</div>

                                        </div>
                                    ))}
                                </div>


                            );
                        })}
                    </div>
                </div>
            )}


            {isMealOrder === true && Object.keys(data).length > 0 && (
                <div style={{ marginTop: '20px', width: '100%', marginLeft: '1px' }}>
                    <div style={{ marginLeft: '1px', fontFamily: 'Inter Medium', fontSize: '12px', color: 'black', }}>
                        Item{data?.item_names?.length > 1 ? 's' : ''}
                    </div>
                    <div style={{ margin: '1px', alignContent: 'center' }}>
                        {data?.item_name?.map((item, i) => {

                            let price = 'Meal item'


                            return (
                                <div style={{ alignContent: 'center', marginBottom: '10px' }} key={`${item}_${i}`}>
                                    <div style={{ display: 'flex', flexDirection: 'row', alignText: 'center', alignContent: 'center' }}>

                                        <div style={{
                                            display: 'flex', fontFamily: 'Inter Medium', fontSize: '11px', justifyContent: 'center', backgroundColor: '#e8e7e9', alignItems: 'center',
                                            border: '1px solid #c7c7c7', borderRadius: '3px', height: '18px', width: '22px', margin: '0px 10px 5px 0px',
                                        }}>{item.qty}</div>
                                        <div style={{ display: 'flex', flexDirection: 'column', }}>
                                            <div style={{ fontFamily: 'Inter Bold', fontSize: '12px', color: '#181436', textTransform: 'capitalize' }}>{item.item}</div>
                                            {item?.promotion && <div style={{ fontFamily: 'Inter Regular', fontSize: '11px', color: '#BABABA', marginTop: '2px', marginBottom: '5px' }}>
                                                Applied - <a style={{ fontFamily: 'Inter Medium', fontSize: '11px', color: 'rgb(69, 165, 23)' }}> {TextTransformation(item?.promotion)}</a></div>}

                                            {item?.product_category && <div style={{ fontSize: '12px', fontFamily: 'Inter Regular', color: 'black' }}>Meal item</div>}

                                        </div>
                                        <div style={{
                                            flex: 1,
                                            textAlign: 'right',
                                            fontFamily: 'Inter Medium',
                                            fontSize: '14px',
                                            color: '#181436',
                                            marginLeft: '10px'
                                        }}> {price}</div>

                                    </div>
                                    {item?.extra_toppings?.map((t, j) => (
                                        <div style={{ display: 'flex', flexDirection: 'row', margin: '0px 0px 0px 35px' }} key={t.topping_name}>
                                            <div style={{ fontFamily: 'Inter Regular', fontSize: '13px', color: '#181436', marginRight: '30px', textTransform: 'capitalize' }}>{`${t.topping_name} (${t.topping_qty})`}</div>
                                            <div style={{ fontFamily: 'Inter Regular', fontSize: '13px', color: '#181436', marginRight: '10px' }}>${(t.topping_qty * t.price).toFixed(2)}</div>

                                        </div>
                                    ))}
                                </div>
                            );
                        })}
                    </div>
                </div>
            )}



            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                <div style={StyleTotalBlock}> Sub total</div>
                <div style={StyleNumberBlock}> ${(data?.sub_total || 0.00)?.toFixed(2)}</div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                <div style={StyleTotalBlock}>  Delivery Fee</div>
                <div style={StyleNumberBlock}> ${(data?.delivery_price)?.toFixed(2) || (data?.deliverySubscription_fee)?.toFixed(2)}</div>
            </div>

            {data?.discount_coupon_no && <div>
                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                    <div style={StyleTotalBlock}>Discount</div>
                    <div style={{ ...StyleNumberBlock, color: 'green' }}> {promoTypeLabel(data?.discount_type, data?.discountedAmount)}</div>
                </div>

                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                    <div style={StyleTotalBlock}> Discount code</div>
                    <div style={{ ...StyleNumberBlock, textTransform: 'uppercase' }}> {(data?.discount_coupon_no)}</div>
                </div>
            </div>
            }


            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                <div style={StyleTotalBlock}>Tax & other fee</div>
                <div style={StyleNumberBlock}> ${(data?.tax_plus_serviceFees || data?.tax)?.toFixed(2)}</div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                <div style={StyleTotalBlock}>Tip</div>
                <div style={StyleNumberBlock}> ${(data?.tip)?.toFixed(2)}</div>
            </div>

            {data?.promoOrderAmountAdded_In_Total_charged !== 0 && <div style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                marginTop: '10px'
            }}>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <div style={{ ...StyleTotalBlock, fontSize: '12px' }}>Complimentary Item</div>
                    <div style={{ fontSize: '11px', color: 'black' }}> Packaging & Delivery Fee</div>
                    <div style={{ fontSize: '11px', color: 'black' }}> Arriving Tomorrow</div>
                </div>

                <div style={StyleNumberBlock}> ${(data?.promoOrderAmountAdded_In_Total_charged)?.toFixed(2)}</div>
            </div>}


            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginTop: '10px' }}>
                <div style={{ ...StyleTotalBlock, fontFamily: 'Inter Bold' }}>Total</div>
                <div style={{ ...StyleNumberBlock, fontFamily: 'Inter Bold' }}> ${(data?.total_charged)?.toFixed(2)}</div>
            </div>


            <div style={{ display: 'flex', flexDirection: 'column', textAlign: 'center' }}>
                <div style={{ fontFamily: 'Inter Bold', marginTop: '30px', fontSize: '11px' }}> We appreciate your order — enjoy your meal! Thanks for choosing us, and see you again soon!</div>

            </div>


        </div>








    </div >)
});

export default Receipt;